import { defineComponent as _defineComponent } from 'vue'


type PropTypes = {
  title: string
  subtitle: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyInfoSection',
  props: {
    title: null,
    subtitle: null
  },
  setup(__props: any) {

const { title, subtitle } = __props as {
  title: string
  subtitle: string
}



return { __sfc: true, }
}

})